// React Thirty Party Library
import React, { useState } from "react"
import { Form, Col, Row, message } from "antd";
import { useDispatch, useSelector } from "react-redux";

// Constants Library
 
// Components Library
import { MainReport } from "../../components";
import { PrimaryButton } from "../../../../components/Decoration/Button";
import DeviceSearchField from "./deviceSearchField.js";
import showSecondarySidebar from '../../../../layout/MainLayout/helpers/showSecondarySidebar';


// Handler 
import { xlsx_handler } from "../../../../handlers/index.js";

import * as REDUX_ACTION from "../../../../services/redux/actions";

import { TIME, REDUX as REDUX_UTIL } from "../../../../services/util";


// Styles Library

const { 
  dayJSMilliSecond, lastNDay, currentTimeMilliSecond, 
  todayStart, todayEnd, parseExportTime } = TIME

const { reduxStoreWrapper } = REDUX_UTIL;

const { exportReportFile } = xlsx_handler


const SearchReport = (props) => { 
    
  const { selectedType, setSelectedType, setShowTable, showTable, dataColumn, dataReport, fileName } = props;

  const loading = useSelector(reduxStoreWrapper("style.loading.report"));
  const device = useSelector(reduxStoreWrapper("devices.staticsByID"));

  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const handleTypeChange = (value) => {
    setSelectedType(value);
    setShowTable(false)
  };

  const onSearchReport = () => { 
    form
      .validateFields()
      .then((val) => {

        const { timeframe, dvids } = val
        setTimeframe(timeframe)

        const startTime = timeframe?.length && dayJSMilliSecond(timeframe[0]) || lastNDay(90)
        const endTime = timeframe?.length && dayJSMilliSecond(timeframe[1]) || currentTimeMilliSecond()
        const devices =  dvids[0] === 'All'
                      ? Object.values(device).map(d => d.dvid)
                      : dvids;

        setSelectedType('device')

        dispatch(REDUX_ACTION.v3_reports.unset_device_log_report_summary_success())

        devices.forEach(device => 
            dispatch(REDUX_ACTION.v3_reports.get_device_log_report_summary_request({ startTime, endTime, dvid: device }, () => { setShowTable(true) }))
        )
        
      }).catch(() => message.error("fill the form"))
  };

  const items = {
    form,
    handleTypeChange
  }

  const initial = {
    'type': selectedType,
    'timeframe': [todayStart, todayEnd],
  }

  const [ timeframe, setTimeframe ] = useState(null)

    const exportDataHandler = () => {

        exportReportFile(dataReport, dataColumn, "Main", `${fileName}_${parseExportTime(timeframe[0])}_${parseExportTime(timeframe[1])}`)
    }


  return (
    <>
        <Form layout="vertical" form={form} initialValues={initial} validateTrigger="onBlur">
          <Row>

            <DeviceSearchField {...items}/>

            <Col>
               <PrimaryButton
                    loading = {loading}
                    onClick = {onSearchReport}
                    style = {{ marginLeft: '15px' }}
                    color='#ED5B57'
                >
                    Submit
                </PrimaryButton>
            </Col>
            <Col>
               <PrimaryButton
                    disabled = {!showTable}
                    onClick = {exportDataHandler}
                    style = {{ marginLeft: '15px' }}
                >
                    Export
                </PrimaryButton>
            </Col>

          </Row>
        </Form>
    </>
  );
};



const DeviceReport = () => {

  return (
     <MainReport type='device' search={<SearchReport />} />
  );
};

const MemorizedDeviceReport = React.memo(DeviceReport);

export default showSecondarySidebar(false)(MemorizedDeviceReport);